import store from "@/store";

export default async (to, from, next) => {
  await store.dispatch("setEvents", {
    page: 1,
    perPage: 10
  });
  next();
};
